export interface LegalArticle {
  title: string;
  content: {
    mainText?: string;
    bulletPoints?: string[];
    additionalText?: string[];
    contactInfo?: string;
  }[];
}

export const legalData: LegalArticle[] = [
  {
    title: "Mentions légales",
    content: [
      {
        mainText:
          "Ce site est édité par le Tennis Club de l’Agglomération du Beauvaisis (TCAB) :",
      },
      {
        bulletPoints: [
          "Propriétaire et éditeur : Tennis Club de l’Agglomération du Beauvaisis (association loi 1901)",
          "Siège social : 7 bis rue Suzanne Lenglen, 60000 Beauvais",
          "Contact : contact@tennis-club-agglo-beauvais.com",
          "Activité : Club de tennis (adhésions, cours, compétitions et événements)",
          "Directeur de la publication : le Président du TCAB",
          "Hébergement : [nom de l’hébergeur du site à insérer, ex : OVH, adresse et contact]",
        ],
      },
      {
        additionalText: [
          "Le Tennis Club de l’Agglomération du Beauvaisis propose des cours, entraînements, compétitions et animations accessibles à tous les niveaux de pratique.",
        ],
      },
    ],
  },
  {
    title: "Protection des données (RGPD)",
    content: [
      {
        mainText:
          "Les formulaires présents sur ce site peuvent collecter certaines données personnelles (nom, prénom, email, téléphone) uniquement pour la gestion des adhésions, contacts et demandes d’informations.",
      },
      {
        bulletPoints: [
          "Les données sont utilisées uniquement par le TCAB et ne sont jamais revendues.",
          "Elles sont conservées le temps nécessaire à la gestion de la relation avec l’adhérent ou le prospect.",
          "Vous disposez d’un droit d’accès, de rectification, d’opposition et de suppression conformément au RGPD.",
        ],
      },
      {
        additionalText: [
          "Les formulaires peuvent inclure un système anti-spam pour sécuriser l’envoi.",
          "Cookies : le site peut utiliser des cookies techniques et analytiques pour améliorer l’expérience utilisateur. Vous pouvez les désactiver dans les paramètres de votre navigateur.",
        ],
      },
      {
        contactInfo:
          "Pour toute demande relative à vos données personnelles : contact@tennis-club-agglo-beauvais.com",
      },
    ],
  },
  {
    title: "Propriété intellectuelle",
    content: [
      {
        mainText:
          "Le contenu du site (textes, images, photos, logos, graphismes) est la propriété exclusive du TCAB, sauf mention contraire.",
      },
      {
        bulletPoints: [
          "Toute reproduction ou utilisation sans accord préalable est interdite.",
          "Les logos et marques présents sur le site sont protégés et ne peuvent être réutilisés sans autorisation.",
        ],
      },
    ],
  },
  {
    title: "Conditions d'utilisation",
    content: [
      {
        mainText: "En utilisant ce site, vous vous engagez à :",
      },
      {
        bulletPoints: [
          "Respecter les lois en vigueur et les droits de propriété intellectuelle",
          "Utiliser le site à des fins personnelles et légitimes",
          "Ne pas perturber son bon fonctionnement (virus, hacking, attaques informatiques, etc.)",
        ],
      },
      {
        additionalText: [
          "Le club met tout en œuvre pour garantir l’exactitude des informations publiées, mais ne saurait être tenu responsable en cas d’erreur ou d’omission.",
        ],
      },
    ],
  },
  {
    title: "Acceptation",
    content: [
      {
        mainText:
          "En accédant à ce site, vous reconnaissez avoir lu et accepté les présentes mentions légales et conditions d’utilisation.",
      },
    ],
  },
];
